"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const LexusLoadingIcon = _styledComponents.default.div`
  animation-name: LoadingLogoPlay;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: steps(21);
  background-position: left center;
  background-image: url(${require("./loading.png")});
  background-size: cover;
  height: 40px;
  width: 56px;
  display: inline-block;
  background-color: transparent;
  border: none;

  @keyframes LoadingLogoPlay {
    100% {
      background-position: 100%;
    }
  }
`;
var _default = exports.default = LexusLoadingIcon;